// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/pages/EditarDados.css — responsivo e com navbar sticky */

:root {
  --bg: #0b0c10;
  --bg-soft: #0f1117;
  --card: #141821;
  --muted: #9aa4b2;
  --text: #e6edf3;
  --primary: #22c55e;
  --primary-700: #16a34a;
  --border: #1f2430;
  --shadow: 0 10px 24px rgba(0,0,0,.35);
  --radius: 16px;
}

/* SHELL GERAL (mobile-first) */
.ed-shell {
  min-height: 100vh;
  background: linear-gradient(180deg, var(--bg) 0%, #0c1018 100%);
  color: var(--text);
  display: flex;
  flex-direction: column; /* mobile-first: empilha navbar e conteúdo */
}

/* NAVBAR (Menu) */
.ed-navbar {
  position: sticky;
  top: 0;
  z-index: 50;
  width: 100%;
  background: rgba(11,12,16,0.9);
  backdrop-filter: saturate(160%) blur(6px);
  border-bottom: 1px solid var(--border);
}

/* se o Menu tiver um container interno, garante largura total */
.ed-navbar > * {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}

/* CONTEÚDO PRINCIPAL */
.ed-content {
  width: 100%;
  max-width: 980px;
  margin: 0 auto;
  padding: 16px; /* mais compacto no mobile */
}

@media (min-width: 960px) {
  .ed-content { padding: 24px; }
}

.ed-header {
  margin: 6px 0 16px;
}
.ed-header h1 {
  font-size: 22px;
  margin: 0 0 6px;
}
.ed-header p {
  margin: 0;
  color: var(--muted);
  font-size: 14px;
}

/* GRID (cards) */
.ed-grid.single {
  display: grid;
  grid-template-columns: 1fr; /* mobile = 1 coluna */
  gap: 14px;
}
@media (min-width: 960px) {
  .ed-grid.single {
    grid-template-columns: 1fr 1fr; /* desktop = 2 colunas */
    gap: 18px;
  }
}

/* CARD */
.ed-card {
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: var(--shadow);
  padding: 14px;
}
@media (min-width: 960px) {
  .ed-card { padding: 16px; }
}

.ed-card-title {
  font-weight: 700;
  font-size: 15px;
  margin-bottom: 12px;
}

/* CAMPOS */
.ed-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 12px;
}
.ed-field label {
  font-size: 13px;
  color: var(--muted);
}
.ed-field input {
  width: 100%; /* evita overflow no mobile */
  background: var(--bg-soft);
  color: var(--text);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 12px;
  outline: none;
  transition: border-color .15s ease, box-shadow .15s ease;
  appearance: none;
  -webkit-appearance: none; /* iOS inputs */
}
.ed-field input:focus {
  border-color: #334155;
  box-shadow: 0 0 0 3px rgba(51,65,85,.25);
}
.ed-help {
  color: var(--muted);
  font-size: 12px;
}

/* AÇÕES */
.ed-actions {
  margin-top: 14px;
  display: flex;
  flex-direction: column; /* empilha botões no mobile */
  gap: 10px;
}
@media (min-width: 560px) {
  .ed-actions {
    flex-direction: row; /* lado a lado em telas médias+ */
    justify-content: flex-end;
  }
}

.ed-btn {
  border: 0;
  border-radius: 12px;
  padding: 12px 16px;
  cursor: pointer;
  font-weight: 700;
  transition: transform .06s ease, filter .2s ease, background-color .2s ease;
  width: 100%; /* botão fluido no mobile */
}
@media (min-width: 560px) {
  .ed-btn { width: auto; }
}
.ed-btn:disabled {
  filter: grayscale(.6) brightness(.8);
  cursor: not-allowed;
}
.ed-btn:active { transform: translateY(1px); }

.ed-btn-primary {
  background: var(--primary);
  color: #051306;
}
.ed-btn-primary:hover { background: var(--primary-700); }

.ed-btn-secondary {
  background: #1f2937;
  color: var(--text);
}
.ed-btn-secondary:hover { filter: brightness(1.08); }

/* ALERTAS & LOADING */
.ed-alert {
  padding: 12px 14px;
  border-radius: 12px;
  margin: 10px 0 14px;
  border: 1px solid transparent;
  line-height: 1.4;
  font-size: 14px;
}
.ed-alert-success {
  background: rgba(34,197,94,.12);
  border-color: rgba(34,197,94,.35);
}
.ed-alert-error {
  background: rgba(239,68,68,.12);
  border-color: rgba(239,68,68,.35);
}

.ed-loading {
  display: flex;
  align-items: center;
  gap: 12px;
}
.ed-spinner {
  width: 18px;
  height: 18px;
  border-radius: 999px;
  border: 3px solid #334155;
  border-top-color: var(--text);
  animation: spin .8s linear infinite;
}
@keyframes spin { to { transform: rotate(360deg); } }

/* HARDENING contra menus que vêm com posição/float próprios */
.ed-navbar nav, .ed-navbar div, .ed-navbar header {
  max-width: 1200px;
  margin: 0 auto;
}
`, "",{"version":3,"sources":["webpack://./src/pages/EditarDados.css"],"names":[],"mappings":"AAAA,+DAA+D;;AAE/D;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,qCAAqC;EACrC,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,iBAAiB;EACjB,+DAA+D;EAC/D,kBAAkB;EAClB,aAAa;EACb,sBAAsB,EAAE,4CAA4C;AACtE;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,WAAW;EACX,8BAA8B;EAC9B,yCAAyC;EACzC,sCAAsC;AACxC;;AAEA,gEAAgE;AAChE;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,aAAa,EAAE,4BAA4B;AAC7C;;AAEA;EACE,cAAc,aAAa,EAAE;AAC/B;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,eAAe;AACjB;AACA;EACE,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,0BAA0B,EAAE,sBAAsB;EAClD,SAAS;AACX;AACA;EACE;IACE,8BAA8B,EAAE,wBAAwB;IACxD,SAAS;EACX;AACF;;AAEA,SAAS;AACT;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,4BAA4B;EAC5B,yBAAyB;EACzB,aAAa;AACf;AACA;EACE,WAAW,aAAa,EAAE;AAC5B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,WAAW,EAAE,6BAA6B;EAC1C,0BAA0B;EAC1B,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,wDAAwD;EACxD,gBAAgB;EAChB,wBAAwB,EAAE,eAAe;AAC3C;AACA;EACE,qBAAqB;EACrB,wCAAwC;AAC1C;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA,UAAU;AACV;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB,EAAE,6BAA6B;EACrD,SAAS;AACX;AACA;EACE;IACE,mBAAmB,EAAE,iCAAiC;IACtD,yBAAyB;EAC3B;AACF;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,2EAA2E;EAC3E,WAAW,EAAE,2BAA2B;AAC1C;AACA;EACE,UAAU,WAAW,EAAE;AACzB;AACA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;AACA,iBAAiB,0BAA0B,EAAE;;AAE7C;EACE,0BAA0B;EAC1B,cAAc;AAChB;AACA,wBAAwB,8BAA8B,EAAE;;AAExD;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA,0BAA0B,wBAAwB,EAAE;;AAEpD,sBAAsB;AACtB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,+BAA+B;EAC/B,iCAAiC;AACnC;AACA;EACE,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,yBAAyB;EACzB,6BAA6B;EAC7B,mCAAmC;AACrC;AACA,kBAAkB,KAAK,yBAAyB,EAAE,EAAE;;AAEpD,8DAA8D;AAC9D;EACE,iBAAiB;EACjB,cAAc;AAChB","sourcesContent":["/* src/pages/EditarDados.css — responsivo e com navbar sticky */\n\n:root {\n  --bg: #0b0c10;\n  --bg-soft: #0f1117;\n  --card: #141821;\n  --muted: #9aa4b2;\n  --text: #e6edf3;\n  --primary: #22c55e;\n  --primary-700: #16a34a;\n  --border: #1f2430;\n  --shadow: 0 10px 24px rgba(0,0,0,.35);\n  --radius: 16px;\n}\n\n/* SHELL GERAL (mobile-first) */\n.ed-shell {\n  min-height: 100vh;\n  background: linear-gradient(180deg, var(--bg) 0%, #0c1018 100%);\n  color: var(--text);\n  display: flex;\n  flex-direction: column; /* mobile-first: empilha navbar e conteúdo */\n}\n\n/* NAVBAR (Menu) */\n.ed-navbar {\n  position: sticky;\n  top: 0;\n  z-index: 50;\n  width: 100%;\n  background: rgba(11,12,16,0.9);\n  backdrop-filter: saturate(160%) blur(6px);\n  border-bottom: 1px solid var(--border);\n}\n\n/* se o Menu tiver um container interno, garante largura total */\n.ed-navbar > * {\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n/* CONTEÚDO PRINCIPAL */\n.ed-content {\n  width: 100%;\n  max-width: 980px;\n  margin: 0 auto;\n  padding: 16px; /* mais compacto no mobile */\n}\n\n@media (min-width: 960px) {\n  .ed-content { padding: 24px; }\n}\n\n.ed-header {\n  margin: 6px 0 16px;\n}\n.ed-header h1 {\n  font-size: 22px;\n  margin: 0 0 6px;\n}\n.ed-header p {\n  margin: 0;\n  color: var(--muted);\n  font-size: 14px;\n}\n\n/* GRID (cards) */\n.ed-grid.single {\n  display: grid;\n  grid-template-columns: 1fr; /* mobile = 1 coluna */\n  gap: 14px;\n}\n@media (min-width: 960px) {\n  .ed-grid.single {\n    grid-template-columns: 1fr 1fr; /* desktop = 2 colunas */\n    gap: 18px;\n  }\n}\n\n/* CARD */\n.ed-card {\n  background: var(--card);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  box-shadow: var(--shadow);\n  padding: 14px;\n}\n@media (min-width: 960px) {\n  .ed-card { padding: 16px; }\n}\n\n.ed-card-title {\n  font-weight: 700;\n  font-size: 15px;\n  margin-bottom: 12px;\n}\n\n/* CAMPOS */\n.ed-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-bottom: 12px;\n}\n.ed-field label {\n  font-size: 13px;\n  color: var(--muted);\n}\n.ed-field input {\n  width: 100%; /* evita overflow no mobile */\n  background: var(--bg-soft);\n  color: var(--text);\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  padding: 12px;\n  outline: none;\n  transition: border-color .15s ease, box-shadow .15s ease;\n  appearance: none;\n  -webkit-appearance: none; /* iOS inputs */\n}\n.ed-field input:focus {\n  border-color: #334155;\n  box-shadow: 0 0 0 3px rgba(51,65,85,.25);\n}\n.ed-help {\n  color: var(--muted);\n  font-size: 12px;\n}\n\n/* AÇÕES */\n.ed-actions {\n  margin-top: 14px;\n  display: flex;\n  flex-direction: column; /* empilha botões no mobile */\n  gap: 10px;\n}\n@media (min-width: 560px) {\n  .ed-actions {\n    flex-direction: row; /* lado a lado em telas médias+ */\n    justify-content: flex-end;\n  }\n}\n\n.ed-btn {\n  border: 0;\n  border-radius: 12px;\n  padding: 12px 16px;\n  cursor: pointer;\n  font-weight: 700;\n  transition: transform .06s ease, filter .2s ease, background-color .2s ease;\n  width: 100%; /* botão fluido no mobile */\n}\n@media (min-width: 560px) {\n  .ed-btn { width: auto; }\n}\n.ed-btn:disabled {\n  filter: grayscale(.6) brightness(.8);\n  cursor: not-allowed;\n}\n.ed-btn:active { transform: translateY(1px); }\n\n.ed-btn-primary {\n  background: var(--primary);\n  color: #051306;\n}\n.ed-btn-primary:hover { background: var(--primary-700); }\n\n.ed-btn-secondary {\n  background: #1f2937;\n  color: var(--text);\n}\n.ed-btn-secondary:hover { filter: brightness(1.08); }\n\n/* ALERTAS & LOADING */\n.ed-alert {\n  padding: 12px 14px;\n  border-radius: 12px;\n  margin: 10px 0 14px;\n  border: 1px solid transparent;\n  line-height: 1.4;\n  font-size: 14px;\n}\n.ed-alert-success {\n  background: rgba(34,197,94,.12);\n  border-color: rgba(34,197,94,.35);\n}\n.ed-alert-error {\n  background: rgba(239,68,68,.12);\n  border-color: rgba(239,68,68,.35);\n}\n\n.ed-loading {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n.ed-spinner {\n  width: 18px;\n  height: 18px;\n  border-radius: 999px;\n  border: 3px solid #334155;\n  border-top-color: var(--text);\n  animation: spin .8s linear infinite;\n}\n@keyframes spin { to { transform: rotate(360deg); } }\n\n/* HARDENING contra menus que vêm com posição/float próprios */\n.ed-navbar nav, .ed-navbar div, .ed-navbar header {\n  max-width: 1200px;\n  margin: 0 auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
